import React from 'react'
import FormattedMessage from '../../helpers/FormattedMessage'
import arrowIcon from '../../assets/icons/icn-arrow-horizontal.svg'
import styles from './InputButton.module.scss'

interface IProps {
  onClick: () => void
  children: React.ReactNode
  label: string
  isError?: boolean
  errorLabel?: string
  select?: boolean
}

export const InputButton = ({ onClick, children, label, isError, errorLabel, select }: IProps) => {
  return (
    <>
      <div className={styles.InputButtonWrapper}>
        <div className={styles.Label}>
          <FormattedMessage id={label}/>
        </div>
        <button className={`${styles.InputButton} ${isError && styles.Error}`} onClick={onClick}>
          <p>{children}</p>
          <img className={select ? styles.Rorate : ''} src={arrowIcon} alt="horizontal arrow"/>
        </button>
      </div>
      {isError && errorLabel &&
        <div className={styles.ErrorText}>
          <FormattedMessage id={errorLabel}/>
        </div>
      }
    </>
  )
}
